module.exports = __webpack_public_path__ + "img/bluebody.727e60e0.png";